import MATERIAL_TYPES from '../../../__core/Enums/MaterialTypes';

const VIEW_WITH_HTML_CONTENT = [
  MATERIAL_TYPES.SNIPPET,
  MATERIAL_TYPES.ARTICLE,
  MATERIAL_TYPES.EXERCISE,
];

export const isMaterialWithHtmlContent = (materialType: string): boolean =>
  !!VIEW_WITH_HTML_CONTENT.find((type: string) => materialType === type);

export const isQuiz = (materialType: string): boolean =>
  materialType === MATERIAL_TYPES.QUIZ;

export const isPresentation = (materialType: string): boolean =>
  materialType === MATERIAL_TYPES.PRESENTATION_PDF ||
  materialType === MATERIAL_TYPES.PRESENTATION_REVEAL;

export const isPresentationReveal = (materialType: string): boolean =>
  materialType === MATERIAL_TYPES.PRESENTATION_REVEAL;

export const isPresentationPdf = (materialType: string): boolean =>
  materialType === MATERIAL_TYPES.PRESENTATION_PDF;

export const isAttachment = (materialType: string): boolean =>
  materialType === MATERIAL_TYPES.ATTACHMENT;
